import { WorkPeriodModel } from "@/context/work_period/model/WorkPeriodModel";
import { Nullable } from "@/general/custom-types/CustomTypes";

export class WorkPeriodTemplate {
  id: Nullable<number>;
  name: string;
  days: Record<string, WorkPeriodModel[]>;

  constructor() {
    this.id = -1;
    this.name = "";
    this.days = {};
  }
}
